module.exports = __webpack_public_path__ + "img/photo-0116.339eeba7.jpg";